import { render, staticRenderFns } from "./ProuniPersonalDocumentsForm.vue?vue&type=template&id=f32dd13e&scoped=true&"
import script from "./ProuniPersonalDocumentsForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniPersonalDocumentsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniPersonalDocumentsForm.vue?vue&type=style&index=0&id=f32dd13e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32dd13e",
  null
  
)

export default component.exports